var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup._model.length
    ? _c(
        "div",
        { staticClass: "draggable-list-wrapper" },
        [
          _c(
            _setup.VueDraggable,
            {
              staticClass: "list",
              attrs: { animation: 200, disabled: !_vm.draggable },
              on: {
                end: function ($event) {
                  return _setup.emit("drag-end", $event)
                },
              },
              model: {
                value: _setup._model,
                callback: function ($$v) {
                  _setup._model = $$v
                },
                expression: "_model",
              },
            },
            _vm._l(_setup._model, function (element, index) {
              return _c(
                "div",
                {
                  key: element[_vm.itemKey],
                  staticClass: "item-row",
                  class: { "bg-purple-lightest": _setup.isSelected(element) },
                  on: {
                    click: function ($event) {
                      return _setup.emit("row-click", element, index)
                    },
                  },
                },
                [
                  _vm.draggable && _setup._model.length > 1
                    ? _c("font-awesome-icon", {
                        staticClass: "mr-3",
                        attrs: { icon: ["fas", "grip-dots-vertical"] },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.hideCounter
                    ? _c("span", { staticClass: "counter" }, [
                        _vm._v(" " + _vm._s(index + 1) + ". "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("item", null, null, {
                    element,
                    index,
                    selected: _setup.isSelected(element),
                  }),
                ],
                2
              )
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }